import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { EmployeeService } from '../../services/employee.service';
import { Router } from '@angular/router';
import { menurolesService } from '../../services/menuroles.service';
import { AuthenticationService } from '../../services/authentication.service';



@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})


export class SidebarComponent implements OnInit, OnDestroy, AfterViewInit {
  public isPageEditable = false;
  public menuList: any[];
  public userMenuList: any[];
  loginUser = JSON.parse(localStorage.getItem('currentUser'));

  constructor(private _employeeServicess: EmployeeService, private router: Router,
    private _menurolesService: menurolesService, private _authService: AuthenticationService) {

  }

  logout() {
    this._authService.logOut();
  }

  get userInitials(): string {
    const name = this.loginUser && this.loginUser.userDetail && this.loginUser.userDetail.name;
    return name ? name.trim().split(/\s+/).map(part => part.charAt(0)).slice(0, 2).join('').toUpperCase() : '';
  }

  ngOnInit() {
    this.getAllMenus();

  }

  @ViewChild('menuScroll') menuScroll: ElementRef;
  private menusSubscription: Subscription;

  getAllMenus() {
    this._menurolesService.ensureMenus();
    this.menusSubscription = this._menurolesService.menus$.subscribe(menus => {
      this.userMenuList = menus ? menus.menuList : [];
      this.isPageEditable = menus ? this._menurolesService.applyPermissions(menus.menuunorder) : false;
    });
  }

  ngAfterViewInit() {
    this.menuScroll.nativeElement.scrollTop = this._menurolesService.sidebarScrollTop;
  }

  saveScroll() {
    this._menurolesService.sidebarScrollTop = this.menuScroll.nativeElement.scrollTop;
  }

  ngOnDestroy() {
    this.saveScroll();
    if (this.menusSubscription) { this.menusSubscription.unsubscribe(); }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts